import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEventById } from '../../Services/arndAPI';
import Loader from '../../Components/Loader/Loader';
import styles from './Styles/Events.module.css';

export default function EventAttendees() {
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        async function fetchEvent() {
            setLoading(true);
            try {
                const data = await getEventById(id);
                setEvent(data);
            } catch {
                setError('Failed to load event attendees');
            } finally {
                setLoading(false);
            }
        }
        fetchEvent();
    }, [id]);

    if (loading) return <Loader />;
    if (error) return <div className={styles.status}>{error}</div>;
    if (!event || !event.eventData) return <div className={styles.status}>No event found</div>;

    const attendees = event.eventData.EventRSVPS || [];

    return (
        <div className={styles.container}>
            <h2>Attendees for {event.eventData.name}</h2>
            <div className={styles.attendeesGrid}>
                                {attendees.length === 0 ? (
                                        <div className={styles.emptyAttendees}>
                                                <svg width="48" height="48" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" style={{marginBottom:'1rem'}}>
                                                    <circle cx="12" cy="12" r="10"/>
                                                    <path d="M8 15c1.333-1 2.667-1 4 0"/>
                                                    <path d="M9 9h.01"/>
                                                    <path d="M15 9h.01"/>
                                                </svg>
                                                <div style={{fontSize:'1.2rem', color:'#374151', fontWeight:500}}>No attendees found</div>
                                                <div style={{color:'#6b7280', fontSize:'1rem', marginTop:'0.5rem'}}>This event currently has no registered attendees.</div>
                                        </div>
                ) : (
                    attendees.map(rsvp => (
                        <div key={rsvp.id} className={styles.attendeeCard}>
                            <h4>{rsvp.attendee.fullName}</h4>
                            <p><strong>Gender:</strong> {rsvp.attendee.gender}</p>
                            <p><strong>Parent:</strong> {rsvp.attendee.parent.fullName || '-'}</p>
                            <p><strong>Email:</strong> {rsvp.attendee.parent.email}</p>
                            <p><strong>Phone:</strong> {rsvp.attendee.parent.phoneNumber || '-'}</p>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
